<template>
    <div v-if="visible" class="notice-detail-components">
        <el-dialog
            class="notice-detail-dialog"
            :visible.sync="visible"
            :model="list"
            :title="$t('Setting.message')"
            left>
            <el-form>
                <el-form-item prop="title" :label="$t('Setting.Message.title')">
                    {{ list.title }}
                </el-form-item>
                <el-form-item prop="createdAt" :label="$t('Common.time')">
                    {{ list.createdAt }}
                </el-form-item>
                <el-form-item prop="content" :label="$t('Setting.content')">
                    <!-- {{ list.content }} -->
                    <div v-html="list.content"></div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog} from 'element-ui';

export default {
    name: 'notice-detail',
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            list: [],
            id: null,
        };
    },
    watch: {
        visible() {},
    },
    methods: {
        open(row) {
            this.id = row.id;
            this.fetchNotice();
            this.visible = true;
        },
        fetchNotice() {
            API.get(`notice/${this.id}`).then((res) => {
                this.list = res;
            });
        },
    },
};

</script>

<style lang="scss">
.notice-detail-components.el-dialog {
    width: 30%;
    height: 250px;
}
</style>
